
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/trucks",
      function () {
        return require("private-next-pages/products/trucks/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/trucks"])
      });
    }
  